"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCall__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractCreation",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "deploymentData",
                type: "bytes",
            },
        ],
        name: "performCreate",
        outputs: [
            {
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "deploymentData",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "performCreate2",
        outputs: [
            {
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6080806040523460155761020b908161001b8239f35b600080fdfe6080604052600436101561001257600080fd5b60003560e01c80634847be6f146100b557634c8c9ea11461003257600080fd5b346100b05760403660031901126100b05760243567ffffffffffffffff81116100b057610065602091369060040161010a565b80516001600160a01b03918301600435f016610082811515610189565b60405190807f4db17dd5e4732fb6da34a148104a592783ca119a1e7bb8829eba6cbadef0b511600080a28152f35b600080fd5b346100b05760603660031901126100b05760243567ffffffffffffffff81116100b0576100e8602091369060040161010a565b80516001600160a01b039160443591908401600435f516610082811515610189565b81601f820112156100b05780359067ffffffffffffffff82116101735760405192601f8301601f19908116603f0116840167ffffffffffffffff81118582101761017357604052828452602083830101116100b057816000926020809301838601378301015290565b634e487b7160e01b600052604160045260246000fd5b1561019057565b60405162461bcd60e51b815260206004820152601960248201527f436f756c64206e6f74206465706c6f7920636f6e7472616374000000000000006044820152606490fdfea2646970667358221220f30c6ad6bf99908f467645a75e687efdd07ed7ff71e0c7dd9554065ad65b573464736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class CreateCall__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.CreateCall__factory = CreateCall__factory;
CreateCall__factory.bytecode = _bytecode;
CreateCall__factory.abi = _abi;
//# sourceMappingURL=CreateCall__factory.js.map